module.exports = {
  // TODO: Figure out which fields are actually needed here then remove the rest from all properties
  gatsbyConfig: {
    property: 'zionlodge',
    copyrightTagline: 'Zion Lodge',
    siteName: 'Zion Lodge',
    siteUrl: 'https://www.zionlodge.com/',
    reCaptchaDBPropertyName: 'Zion Lodge',
    reCaptchaPublicKey: '6LfiiYIUAAAAAEvSxGg7A_ZOQRemWMgGBoTr0Z5P',
    oliveTravelPropertyId: 'ol_pty_MPpYsgtwUy2lI23gEmT',
    color: '#009CDB',
    facebook: '',
    instagram: '',
    twitter: '',
    youtube: '',
    robots: [],
    dynamicTypes: [
      'pressRelease',
      'event',
      'blog',
    ],
    metaImageFallbackUrl: '',
    onetrustID: '0196035f-4218-7a2b-bbe5-99ef7a5b8066',
  },
};
